// import React, { useEffect, useState } from "react";
// import "./Category_section.css";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/navigation";
// import { Nav } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";

// import {
//   getAllCategories,
//   getAllSubCategory,
// } from "../../../features/master/masterSlice";

// import Category_Subcategory_Card from "../../common-components/category_subcategory_card/Category_Subcategory_Card";
// import { encodeId } from "../../../utils/common";

// const Category_section = () => {
//   const [swiperInstance, setSwiperInstance] = useState(null);
//   const [status, setStatus] = useState("");
//   const [selectedCategoryId, setSelectedCategoryId] = useState("");

//   const dispatch = useDispatch();
//   const location = useLocation();

//   const queryParams = new URLSearchParams(location.search);
//   const categoryId = queryParams.get("category_id");

//   // Redux state
//   const category = useSelector((state) => state?.master?.categories);

//   const navigate = useNavigate();

//   useEffect(() => {
//     dispatch(getAllCategories());
//   }, [dispatch]);

//   const handleCategoryClick = (category_id) => {
//     console.log("handleCategoryClick", category_id);
//     setStatus("");
//     setSelectedCategoryId(category_id);
//     dispatch(getAllSubCategory({ category_id }));
//   };

//   return (
//     <section className="Category_section">
//       <div className="container">
//         <div className="heading_holder">
//           <h4 className="heading_text">Featured Categories</h4>
//         </div>

//         <div className="cat_subcat_div">
//           {status === "noCategory" ? (
//             <p className="text-danger">No category available.</p>
//           ) : (
//             <div className="flex-row row p-0 mb-3">
//               {category?.slice(0, 3)?.map((slide, index) => (
//                 <div className="col-md-4 col-sm-6 col-6">
//                   <div key={index} className="product-slide">
//                     <Nav.Item>
//                       <Nav.Link
//                         eventKey={slide?.id}
//                         active={selectedCategoryId === slide?.id}
//                         onClick={() =>
//                           navigate(`/categories?category_id=${encodeId(slide?.id)}`, {
//                             state: { category_id: slide?.id },
//                           })
//                         }
//                       >
//                         <Category_Subcategory_Card
//                           className="product-image"
//                           content={slide?.name}
//                           image={process.env.REACT_APP_IMG_URL + slide?.image}
//                           imgClassName="category-image"
//                         />
//                         <div className="triangle-right"></div>
//                       </Nav.Link>
//                     </Nav.Item>
//                   </div>
//                 </div>
//               ))}

//               {/* <Swiper
//                                 className="mySwiper"
//                                 onSwiper={(swiper) => setSwiperInstance(swiper)}
//                                 pagination={{
//                                     dynamicBullets: true,
//                                     clickable: true,
//                                 }}
//                                 loop={true}
//                                 modules={[Pagination, Navigation]}
//                                 breakpoints={{
//                                     0: { slidesPerView: 2, spaceBetween: 10 },
//                                     350: { slidesPerView: 3, spaceBetween: 10 },
//                                     486: { slidesPerView: 3, spaceBetween: 10 },
//                                     576: { slidesPerView: 4, spaceBetween: 10 },
//                                     768: { slidesPerView: 5, spaceBetween: 10 },
//                                     992: { slidesPerView: 6, spaceBetween: 10 },
//                                     1200: { slidesPerView: 6, spaceBetween: 10 },
//                                 }}

//                             >
//                                 {category?.map((slide, index) => (
//                                     <SwiperSlide key={index} className="product-slide">

//                                         <Nav.Item>
//                                             <Nav.Link
//                                                 eventKey={slide?.id}
//                                                 active={selectedCategoryId === slide?.id}
//                                                 onClick={() => navigate("/categories", { state: { category_id: slide?.id } })}
//                                             >
//                                                 <Category_Subcategory_Card
//                                                     className="product-image"
//                                                     content={slide?.name}
//                                                     image={
//                                                         process.env.REACT_APP_IMG_URL + slide?.image
//                                                     }
//                                                     imgClassName="category-image"
//                                                 />
//                                                 <div className="triangle-right"></div>
//                                             </Nav.Link>
//                                         </Nav.Item>
//                                     </SwiperSlide>
//                                 ))}
//                             </Swiper> */}
//             </div>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Category_section;

import React, { useEffect, useState } from "react";
import "./Category_section.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import {
  getAllCategories,
  getAllFeaturedCategories,
  getAllSubCategory,
} from "../../../features/master/masterSlice";

import Category_Subcategory_Card from "../../common-components/category_subcategory_card/Category_Subcategory_Card";
import { encodeId } from "../../../utils/common";

const Category_section = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [status, setStatus] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const categoryId = queryParams.get("category_id");

  const category = useSelector((state) => state?.master?.featured_categories);

  useEffect(() => {
    dispatch(getAllFeaturedCategories());
  }, [dispatch]);

  useEffect(() => {
    if (categoryId) {
      setSelectedCategoryId(categoryId);
    }
  }, [categoryId]);

  const handleCategoryClick = (category_id) => {
    setStatus("");
    setSelectedCategoryId(category_id);

    dispatch(getAllSubCategory({ category_id }));
  };

  if (category?.length <= 0) {
    return null;
  }

  return (
    <section className="Category_section">
      <div className="container">
        <div className="heading_holder">
          <h4 className="heading_text">Featured Categories</h4>
        </div>

        <div className="cat_subcat_div">
          {status === "noCategory" ? (
            <p className="text-danger">No category available.</p>
          ) : (
            <Swiper
              className="categorySwiper"
              onSwiper={(swiper) => setSwiperInstance(swiper)}
              modules={[Pagination, Navigation, Autoplay]}
              loop={category?.length > 4}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              navigation={true}
              pagination={{
                clickable: true,
              }}
              speed={800}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                350: {
                  slidesPerView: 2,
                  spaceBetween: 12,
                },
                576: {
                  slidesPerView: 3,
                  spaceBetween: 15,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 15,
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 18,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              }}
            >
              {category?.map((slide, index) => (
                <SwiperSlide key={slide?.id || index} className="product-slide">
                  <Nav.Item>
                    <Nav.Link
                      eventKey={slide?.id}
                      active={selectedCategoryId === slide?.id}
                      onClick={() => {
                        handleCategoryClick(slide?.id);

                        navigate(
                          `/categories?category_id=${encodeId(slide?.id)}`,
                          {
                            state: {
                              category_id: slide?.id,
                            },
                          },
                        );
                      }}
                    >
                      <Category_Subcategory_Card
                        className="product-image"
                        content={slide?.name}
                        image={process.env.REACT_APP_IMG_URL + slide?.image}
                        imgClassName="category-image"
                      />

                      <div className="triangle-right"></div>
                    </Nav.Link>
                  </Nav.Item>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
    </section>
  );
};

export default Category_section;
